const Sort = (props) => {
  return (
    <div {...props}>
      <svg width="9" height="12" viewBox="0 0 9 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M4.5 1.14321L8.14645 4.85109C8.34171 5.04964 8.65829 5.04964 8.85355 4.85109C9.04882 4.65253 9.04882 4.33062 8.85355 4.13207L4.99497 0.20848C4.72161 -0.0694921 4.27839 -0.0694942 4.00503 0.208479L0.146447 4.13207C-0.0488155 4.33062 -0.0488155 4.65253 0.146447 4.85109C0.341709 5.04964 0.658291 5.04964 0.853553 4.85109L4.5 1.14321Z" fill="#767586"/>
      <path fillRule="evenodd" clipRule="evenodd" d="M4.5 10.8568L8.14645 7.14891C8.34171 6.95036 8.65829 6.95036 8.85355 7.14891C9.04882 7.34747 9.04882 7.66938 8.85355 7.86793L4.99497 11.7915C4.72161 12.0695 4.27839 12.0695 4.00503 11.7915L0.146447 7.86793C-0.0488155 7.66938 -0.0488155 7.34747 0.146447 7.14891C0.341709 6.95036 0.658291 6.95036 0.853553 7.14891L4.5 10.8568Z" fill="#000000"/>
      </svg>
    </div>
  )
}

export default Sort